import type { PipeTransform } from '@angular/core';
import { Pipe } from '@angular/core';

@Pipe({
    name: 'queryParams'
}) export class QueryParamsPipe implements PipeTransform {

    transform(key: string, queryValue: any = 1) {
        return { [key]: queryValue };
    }

}
